export class TrDialog {
  open() {

  }

  close() {

  }
}